import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { SelectableComponent } from '../../../../../shared/components/group-selection/selectable/selectable.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { Location } from '../../../../../../models/company/dto/location';

@Component({
  selector: 'app-template-location-selection',
  templateUrl: './template-location-selection.component.html',
  styleUrls: ['./template-location-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TemplateLocationSelectionComponent extends SelectableComponent implements OnChanges {
  @Input() viewOnlyMode: boolean = false;
  @Input() showAddedOrRemovedStatus: boolean = false;
  @Input() originalRequiredLocationIds: number[];
  @Input() updatedRequiredLocationIds: number[];
  @Input() override selection: Location;
  @Input() isChild: boolean = true;
  @Input() disabled: boolean = false;

  protected override _selection = new BehaviorSubject<Location>(null);
  public override selection$: Observable<Location>;
}
